import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { supabase } from "@/lib/supabase";
import { invalidateFor } from "@/lib/cache-registry";

export interface ImportCustomersResult {
  success?: boolean;
  poCustomerCount?: number;
  upsertedCount?: number;
  totalInDb?: number;
  errors?: string[];
}

/**
 * VIB-1157: Trigger PowerOffice -> Supabase kundesync fra Integrasjoner-siden.
 * Edge function `import-customers` henter alle PO-kunder og upserter på
 * `poweroffice_customer_id` (idempotent, rører ikke eksisterende koblinger).
 * Admin-gating skjer i edge function. Cron kjører samme funksjon daglig.
 */
export function useImportCustomers() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (): Promise<ImportCustomersResult> => {
      const { data, error } =
        await supabase.functions.invoke<ImportCustomersResult>(
          "import-customers",
          { body: { dryRun: false } },
        );
      if (error) throw error;
      return data ?? {};
    },
    onSuccess: async (data) => {
      await invalidateFor(qc, "customers");
      toast.success(
        `Kunder synket fra PowerOffice — ${data.poCustomerCount ?? 0} i PO, ${data.totalInDb ?? 0} totalt i basen`,
      );
    },
    onError: (err) => {
      toast.error(`Kundesync feilet: ${(err as Error).message}`);
    },
  });
}
